<div>
  <input set-focus type="text" id="search-box" class="form-control" autocomplete="off"
    placeholder="{{ 'app.search' | translate }}" [(ngModel)]="term" (click)="onClick()"
    (clickOutside)="onClickedOutside($event)">

  @if (showSearch) {
  <div class="search-result">
    @switch (status) {
    @case ('ok') {
    @for (owner of owners | stringFilter:term; track $index) {
    <div (click)="onSelectOwner(owner)">
      {{ owner.fullName }}
    </div>
    }
    }
    @case ('busy') {
    <div class="spinneram spinner-padding-top">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
      {{'app.loading-message'| translate}}
    </div>
    }
    }
  </div>
  }
</div>